import { extractParams } from '@zapier/url-utils';

// Returns true if querystring contains `auto_upgrade=true`.
export const getAutoUpgradeFromUrl = () => {
  let autoUpgradeFromUrl;

  if (typeof window !== 'undefined') {
    const { auto_upgrade } = extractParams(window.location.href);
    autoUpgradeFromUrl = auto_upgrade;
  }

  return autoUpgradeFromUrl === 'true';
};
